
define('jsx!components/pebblego-login-portal',[
	"react",
	"shared/client",
	"jsx!components/login-portal/input-domain",
	"jsx!components/login-public-tenant/input-username",
	"jsx!components/login-public-tenant/input-password",
	"jsx!components/shared/login-image-picker",
	"js-cookie"
], function (React, Client, InputDomain, InputUsername, InputPassword, InputImagePicker, JSCookie) {
	var NEXT_ARROW = "/images/next_arrow.png";
	var USERNAME_ICON = "/images/username_icon.png";
	var PASSWORD_ICON = "/images/password_icon.png";

    return React.createClass({
        displayName: "PebbleGoLoginPortal",
		clearMessageTimeout: null,
		shouldRenderImageAuth: false,
		getInitialState: function () {
			this.resetClearmessageTimeout();
			return {
				// If client is public tenant then let the user input the domain, otherwise we will fecth tenant info from url
				"tenant": window.appData.client.is_public ? null : this.fetchTenant(),
				// From pebblego site, no user will access the pebblego-login with going to private tenant. So assume to move them to next step
				"progress": window.appData.client.is_public ? 0 : 1,
				"username": null,
				"password": null,
				"authentication_method": "password",
				"message": null,
				"image_set": [],
				"request_in_progress": false,
			};
		},
		componentDidMount: function () {
			if (JSCookie.get('client_canonical_name') !== undefined && window.appData.client.is_public) {
				// Check the origin/referrer to see if the user arrived to this page from pebblego stie vs. pressing back or using saved link
				if 
					('referrer' in  document && (
							(document.referrer.indexOf(window.appData.config.pebblego_base_uri) !== -1) ||
							(document.referrer.indexOf(window.appData.config.pebblego_article_base_uri) !== -1) ||
							(document.referrer.indexOf(window.appData.config.pebblego_next_base_uri) !== -1) ||
							(document.referrer.indexOf(window.appData.config.pebblego_shell_base_uri) !== -1)
						)
					) {
						this.generateReturnUrl(JSCookie.get('client_canonical_name'));
				}
			}
		},
		componentDidUpdate: function (prevProps, prevState) {
			var self = this;

			// If we have just finished selecting two images for image_set auth,
			// trigger a login.
			if (self.state.authentication_method === "image_set") {
				if (prevState.image_set.length == 1 && self.state.image_set.length == 2) {
					
					// We implement a short delay so it does not look jarring
					window.setTimeout(function () {
						// We execute the login using the image titles, not the whole object.
						var authValue = self.state.image_set.map(function (image) {
							return image.title;
						});
						self.executeSignInRequest(authValue);
					}, 500);
				}
			}
		},
		/**
		 * Function to fetch tenant info on load of non public tenant
		 * @author Tim Lee
		 * @date 12/08/2021
		 */
		fetchTenant: function () {
			var self = this;
			$.get(window.appData.client.api_url + "/client")
			.done(function (response) {
				self.setState({
					tenant: response.data,
				});
			});
		},
		resetClearmessageTimeout: function () {
			var self = this;
			if(this.clearMessageTimeout) {
				window.clearTimeout(this.clearMessageTimeout);
			}
			this.clearMessageTimeout = window.setTimeout(function () {
				self.setState({
					"message": null
				});
				self.clearMessageTimeout = null;
			}, 10000);
		},
		setMessage: function(message) {
			this.resetClearmessageTimeout();
			this.setState({
				"message": message
			});
		},
		generateReturnUrl: function(canonical_name) {
			let returnParam = ""; // value of return_to param if the parameter exist in url
			let returnURL = ""; // url that will be newly written based with correct tenant subdomain url
			let returnURLParam = ""; // parameter of the value in return_to. Ex) module_id, title

			if (window.location.search) {
				returnParam = (new URLSearchParams(window.location.search)).get('return_to');
			}

			if (returnParam !== "" && returnParam !== null) {
				returnURLParam = (new URL(decodeURIComponent(returnParam))).search;
				const returnPath = new URL(returnParam).pathname;
				if (returnURLParam === "") {
					returnURL = "https://" + window.appData.config.web_base_uri.replace("{client}", canonical_name) + returnPath;
				} else {
					returnURL = "https://" + window.appData.config.web_base_uri.replace("{client}", canonical_name) + returnPath + returnURLParam;
				}
			}

			if (returnURL !== "") {
				window.location = "https://" + window.appData.config.web_base_uri.replace("{client}", canonical_name) + "/pebblego-login?return_to=" + encodeURIComponent(returnURL);
			} else {
				window.location = "https://" + window.appData.config.web_base_uri.replace("{client}", canonical_name) + "/pebblego-login";
			}
		},
		incrementProgress: function () {
			try{
				if (this.state.authentication_method === "image_set") {
					this.shouldRenderImageAuth = true;
				}

				if (this.state.progress === 1) {
					/**
					 * Check if username has all valid cahracters. Does not mean if username will exist or not, means that it will be valid for request
					 * Then, fire a exist request to see if the username exist
					 * After checking username, direct user to appropriate authentication method: password or image
					 * Then, check the password/image and let the user in or reject if any of those field are wrong.
					 */
					
					// run username check if exist when username is not null and password + auth method is null
					// run sign in request when username is not null and auth method is also not null

					if (typeof this.state.username !== "string" || this.state.username.length == 0) {
						throw new Error("Please enter a username.");
					}

					const validUsername = new RegExp(/^[\p{L}0-9!#$%&*\\'+^?`{}|~@_\.\-\/]+$/iu);
					if (!validUsername.test(this.state.username)) {
						throw new Error("Username contains an invalid character.");
					}

					if (this.state.username.length > 255) {
						throw new Error("Username is too long.");
					}

					this.validateUsernameExists();
				} else if (this.state.progress === 2) {
					this.executeSignInRequest(this.state.password);
				} else if (this.state.progress === 0 && this.state.tenant.canonical_name !== window.appData.client.public_client_name) {
					// If user is has not inputed public tenant domain into the progress 0 input box then proceed to new url
					JSCookie.set('client_canonical_name', this.state.tenant ? this.state.tenant.canonical_name : "" );
					this.generateReturnUrl(this.state.tenant.canonical_name);
				} else {
					this.setState({
						"progress": this.state.progress + 1
					});
				}
			} catch (err) {
				this.setMessage(err.message);
			}
		},
		decrementProgress: function () {
			if (this.state.progress === 1 && window.appData.client.is_public === false) {
				this.generateReturnUrl(window.appData.client.public_client_name);
				// The site will reload, no need to proceed to reset of the code. So return to end the function.
				return;
			}

			// back button pressed during image auth, return to username view
			if (this.state.progress === 2) {
				this.shouldRenderImageAuth = false;
			}

			this.setState({
				"progress": Math.max(0, this.state.progress - 1)
			});
		},
		validateUsernameExists: function ()
		{
			var self = this;
			var requestId = Date.now();
			this.validationRequestId = requestId;

			$.get(window.appData.client.api_url + "/users/exists", {
				"username": this.state.username
			})
			.done(function (response) {
				if (self.validationRequestId !== requestId) {
					return;
				}

				/*
				 * If the user has been deleted, let them know.
				 */
				if (typeof response.data.deleted_at === "string") {
					self.setState({
						"message": "This account has been deactivated."
					});
					return;
				}

				self.setState({
					"message": null,
					"progress": self.state.progress + 1
				});

				/*
				 * If the user can be authenticated via image-set login.
				 * let the parent component know.
				 */
				if (response.data.supports_image_set_auth) {
					self.setAuthenticationMethod("image_set");
				} else {
					self.setAuthenticationMethod("password");
				}
			})
			.fail(function (jqXHR) {
				if (self.validationRequestId !== requestId) {
					return;
				}
			})
			.always(function () {
				self.setValidating(false);
				self.setUsername(self.state.username);
				self.validationRequestId = null;
			});
		},
		executeSignInRequest: function (authentication_value) {
			var self = this;
			this.setState({
				"request_in_progress": true
			});

			var loginData = {
				"username": this.state.username,
				"authentication_method": this.state.authentication_method || "password",
				"authentication_value": authentication_value,
				"login_from": "pebblego",
			}

			// If return url param exist, then included into request data
			var returnParam = ""
			if (window.location.search) {
				returnParam = new URLSearchParams(window.location.search).get('return_to');
				if (returnParam !== "") {
					loginData['return_to'] = returnParam;
				}
			}

			// gets the current web base and adds the user inputted tenant name
			let tenantURL = "https://" + window.appData.config.web_base_uri.replace("{client}", this.state.tenant.canonical_name);
			$.post(tenantURL + "/login", loginData)
			.done(function (response) {
				if (response.error) {
					if (/not.+verified/.test(response.error)) {
						self.setState({
							"message":response.error,
							"resend_verification_email_recipient": self.state.username,
						});
					} else {
						self.setState({
							"message":response.error
						});
					}
				} else {
					window.location = response.redirect_to;
				}
			})
			.fail(function (jqXHR) {
				if (self.state.authentication_method === "image_set") {
					// If the auth failed, clear the selected set, but show the image picker again.
					// We clear out image_set first, and then set message because
					// message gets wiped out when the component detects a change
					// in auth values.
					self.setState({ "image_set": [], }, function () {
						self.setMessage(jqXHR.responseText);
					});
				} else {
					if ((jqXHR.responseText || "").indexOf("credentials were incorrect") > -1) {
						self.setMessage("Oops! Incorrect Username Or Password. Please Try Again.");
					} else if (jqXHR.responseText.indexOf("The username format is invalid.") > -1) {
						self.setMessage("Oops! The username contains an invalid character. Please Try Again.");
					}  else if (jqXHR.responseText.indexOf("The authentication value field is required when authentication method is present") > -1) {
						self.setMessage("Password cannot be empty");
					} else {
						self.setMessage("Failed to execute sign in request.");
					}
				}
			})
			.always(function () {
				self.setState({
					"request_in_progress": false
				});
			});
		},
		generateFormText: function (progress) {
			switch (progress) {
				case 0:
					return "Enter Domain";
				case 1:
					return this.state.tenant ? this.state.tenant.name : "";
				case 2:
					if (this.state.authentication_method === "image_set" ||
						this.state.authentication_method === "password") {
						return this.state.username;
					} else {
						return this.state.tenant ? this.state.tenant.name : "";
					}
			}
		},
		renderBackButton: function () {
			var buttonClassList = ['btn', 'circle'];
			if (document.getElementById("banner") !== null) {
				buttonClassList.push("banner-present");
			}

			return (this.state.progress === 0)
				?  (React.createElement("a", {className: buttonClassList.join(" "), href: window.appData.config.pebblego_base_uri + "home"}, 
						React.createElement("img", {className: "back-arrow", src: NEXT_ARROW, alt: "back-arrow-button"})
					))
				: (React.createElement("div", {className: buttonClassList.join(" "), onClick: this.decrementProgress}, 
						React.createElement("img", {className: "back-arrow", src: NEXT_ARROW, alt: "back-arrow-button"})
					));
		},
		renderImageAuthWindow: function () {
			var self = this;

			return (
				React.createElement("div", {className: "pebblego-image-auth"}, 
					React.createElement("h3", null,  this.generateFormText(this.state.progress) ), 
					React.createElement("div", {className: "alert-message"}, this.state.message), 
					React.createElement("span", {className: "password-header"}, "Select Your Password Images"), 
					React.createElement(InputImagePicker, {
						selected_images:  this.state.image_set, 
						onChange:  function (selected_images) {
							self.setState({ image_set: selected_images });
						}}
					)
				)
			);
		},
		handleEnterKeyUp: function () {
			// make sure user doesn't advance in portal when next button is also disabled
			if (!this.state.request_in_progress) {
				// make sure user doesn't advance in portal with blank fields
				if (this.state.progress == 0 && this.state.tenant !== null ||
					this.state.progress == 1 && this.state.username !== null ||
					this.state.progress == 2 && this.state.password !== null) {
					this.incrementProgress();
				}
			}
		},
		handleClickOnSignInWithGoogleButton: function () {
			var uri = window.appData.config.api_base_uri.replace("{client}", this.state.tenant.canonical_name);
			window.location = "https://" + uri + "/login/external/google-pebblego";
		},
		handleClickOnSignInWithMicrosoftButton: function () {
			var uri = window.appData.config.api_base_uri.replace("{client}", this.state.tenant.canonical_name);
			window.location	= "https://" + uri + "/login/external/microsoft-pebblego";
		},
		handleClickOnSignInWithCleverButton: function () {
			var uri = window.appData.config.api_base_uri.replace("{client}", this.state.tenant.canonical_name);
			window.location = "https://" + uri + "/login/external/clever-pebblego";
		},
		handleClickOnSignInWithClassLinkButton: function () {
			var uri = window.appData.config.api_base_uri.replace("{client}", this.state.tenant.canonical_name);
			window.location = "https://" + uri + "/login/external/classlink-pebblego";
		},
		setValidating: function () {
			this.setState({ request_in_progress: status});
		},
		setAuthenticationMethod: function (auth) {
			this.setState({ authentication_method: auth });
		},
		setUsername: function (username) {
			this.setState({ username: username });
		},
        renderFormContent: function () {
			var self = this;
			var formGroup;
			var nextButtonClassNames = ["btn", "next-button"];
			var formTextClassNames = ["form-text"];

			if (this.state.request_in_progress) {
				nextButtonClassNames.push("disabled");
			}

			if (this.state.tenant === null) {
				nextButtonClassNames.push("disabled");
			}

			if (this.state.progress === 1 && this.state.username === null) {
				nextButtonClassNames.push("disabled");
			}

			if (this.state.progress === 2 && this.state.password === null) {
				nextButtonClassNames.push("disabled");
			}

			switch (this.state.progress) {
				default:
				case 0:
					formTextClassNames.push("domain");
					formGroup = (
						React.createElement(InputDomain, {
							tenant:  this.state.tenant, 
							handleEnterKeyUp:  this.handleEnterKeyUp, 
							setTenant:  function (tenant) {
								self.setState({ tenant: tenant });
							}, 
							isPebbleGoPortal:  true }
						)
					);
					break;
				case 1:
					formTextClassNames.push("username");
					formGroup = (
						React.createElement(InputUsername, {
							username:  this.state.username, 
							handleEnterKeyUp:  this.handleEnterKeyUp, 
							setErrorMessage:  function (error) {
								self.resetClearmessageTimeout();
								self.setState({ message: error });
							}, 
							setUsername: this.setUsername, 
							isPebbleGoPortal:  true, 
							usernameImage:  USERNAME_ICON }
						)
					);
					nextButtonClassNames.push("username");
					break;
				case 2:
					if (this.state.authentication_method === "image_set") {
						this.shouldRenderImageAuth = true;
						return;
					} else if (this.state.authentication_method === "password") {
						formTextClassNames.push("password");
						formGroup = (
							React.createElement(InputPassword, {
								password:  this.state.password, 
								handleEnterKeyUp:  this.handleEnterKeyUp, 
								setPassword:  function (password) {
									self.setState({ password: password });
								}, 
								isPebbleGoPortal:  true, 
								passwordImage:  PASSWORD_ICON }
							)
						);
					}
					nextButtonClassNames.push("password");
					break;
			}

			var ssoFormGroup = (
				React.createElement("div", null, 
					 this.state.tenant && this.state.tenant.sync_strategy === "google" ?
						React.createElement("div", {className: "form-group password-sso"}, 
							React.createElement("span", {className: "password-sso-header"}, "Your account uses Google to Sign In."), 
							React.createElement("button", {
								className: "btn rectangle btn-google", 
								id: "btn-sign-in-google", 
								onClick: this.handleClickOnSignInWithGoogleButton}, 
								React.createElement("span", {className: "icons8-google"}), 
								"Sign In with Google"
							)
						) : null, 
					 this.state.tenant && this.state.tenant.sync_strategy === "microsoft" ?
						React.createElement("div", {className: "form-group password-sso"}, 
							React.createElement("span", {className: "password-sso-header"}, "Your account uses Microsoft to Sign In."), 
							React.createElement("button", {
								className: "btn rectangle btn-microsoft", 
								id: "btn-sign-in-microsoft", 
								onClick: this.handleClickOnSignInWithMicrosoftButton}, 
								"Sign In with Microsoft"
							)
						) : null, 
					 this.state.tenant && this.state.tenant.sync_strategy === "clever" ?
					React.createElement("div", {className: "form-group password-sso"}, 
						React.createElement("span", {className: "password-sso-header"}, "Your account uses Clever to Sign In."), 
						React.createElement("button", {
							className: "btn rectangle btn-clever", 
							id: "btn-sign-in-clever", 
							onClick: this.handleClickOnSignInWithCleverButton}, 
							"Sign In with Clever"
						)
						) : null, 
					 this.state.tenant && this.state.tenant.sync_strategy === "classlink" ?
					React.createElement("div", {className: "form-group password-sso"}, 
						React.createElement("span", {className: "password-sso-header"}, "Your account uses ClassLink to Sign In."), 
						React.createElement("button", {
							className: "btn rectangle btn-classlink", 
							id: "btn-sign-in-classlink", 
							onClick: this.handleClickOnSignInWithClassLinkButton}, 
							"Sign In with ClassLink"
						)
						) : null
				)
			);

			return (
				React.createElement("div", {className: "form-groups"}, 
					React.createElement("h3", {className: formTextClassNames.join(" ")},  this.generateFormText(this.state.progress) ), 
					 this.state.progress > 0 ? ssoFormGroup : null, 
					formGroup, 
					React.createElement("div", {className: "alert-message"}, this.state.message), 
					React.createElement("div", {className: nextButtonClassNames.join(" "), onClick: this.incrementProgress}, 
						"Next", 
						React.createElement("img", {className: "next-arrow", src: NEXT_ARROW, alt: "next-arrow-button"})
					)
				)
			);
		},
		renderLoginForm: function () {
			var formClassNames = ["pebblego-login-form"];
			if ((this.state.tenant && this.state.tenant.sync_strategy === "google" ||
				this.state.tenant && this.state.tenant.sync_strategy === "microsoft" ||
				this.state.tenant && this.state.tenant.sync_strategy === "clever") &&
				(this.state.progress === 1 || this.state.progress === 2)) {
				formClassNames.push("sso");
			}

			return (
				React.createElement("div", {className: formClassNames.join(" ")}, 
					React.createElement("div", {className: "login-form-body"}, 
						 this.renderFormContent() 
					)
				) 
			);
		},
        render: function () {
			var portalWrapperClassNames = ["portal-wrapper"];
			var portalClassNames = ["pebblego-login-portal"];
			if (this.shouldRenderImageAuth) {
				portalWrapperClassNames.push("image-auth");
				portalClassNames.push("image-auth");
			}

			return (
				React.createElement("div", {className: portalWrapperClassNames.join(" ")}, 
					React.createElement("div", {className: "portal-header"}, 
						 this.renderBackButton() 
					), 

					React.createElement("div", {className: portalClassNames.join(" ")}, 
						React.createElement("img", {className: "portal-logo", src: Client.assetURL('/images/pebblego/PebbleGo_Create_logo.svg'), alt: "pebblego-create-logo"}), 
						 this.shouldRenderImageAuth ? this.renderImageAuthWindow() : this.renderLoginForm()
					), 

					React.createElement("footer", {className: "login-footer-links"}, 
						React.createElement("a", {className: "footer-link", target: "_blank", href: "https://www.capstonepub.com/support/legal-central"}, "© ", new Date().getFullYear(), " Capstone. All Rights Reserved. ", React.createElement("img", {className: "new-window-icon", src: Client.cdnURL("/images/dashboard/new-window-icon.png")})), 
						React.createElement("div", {className: "footer-divider"}), 
						React.createElement("a", {className: "footer-link privacy", target: "_blank", href: "https://www.capstonepub.com/support/privacy-central"}, "Privacy Central ", React.createElement("img", {className: "new-window-icon", src: Client.cdnURL("/images/dashboard/new-window-icon.png")})), 
						React.createElement("div", {className: "footer-divider"}), 
						React.createElement("a", {className: "footer-link privacy", target: "_blank", href: "https://www.capstonepub.com/support/privacy-central/corporate-privacy-notice#california-privacy-rights"}, "CA Privacy Notice ", React.createElement("img", {className: "new-window-icon", src: Client.cdnURL("/images/dashboard/new-window-icon.png")}))
					)
				)
			);
		}
    });
});
